import { backendUrl } from "@/libs/backend-url";
import { isServer } from "@/libs/isServer";

const SESSION_ID_KEY = "bh.tactsuit-recommend.session-id";

/**
 * 동일 브라우저의 중복 응답 추적용. localStorage 차단 환경(시크릿 + privacy 정책 등)에선
 * 매 호출마다 일회성 ID로 폴백 — 이 경우 중복 카운트는 감수.
 */
function getOrCreateSessionId(): string {
  if (isServer) return "";
  try {
    const existing = window.localStorage.getItem(SESSION_ID_KEY);
    if (existing) return existing;
    const fresh = generateId();
    window.localStorage.setItem(SESSION_ID_KEY, fresh);
    return fresh;
  } catch {
    return generateId();
  }
}

function generateId(): string {
  if (typeof crypto !== "undefined" && "randomUUID" in crypto) {
    return crypto.randomUUID();
  }
  return `anon-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
}

export interface SaveTactSuitRecommendInput {
  platforms: string[];
  genres: string[];
  purchaseFeatures: string[];
  locale?: string;
  /** 있으면 Authorization 헤더로 전달 — 서버가 토큰의 uid를 신뢰한다. body의 uid는 보내지 않는다. */
  bearerToken?: string;
}

/**
 * Fire-and-forget. caller가 await할 필요가 없도록 sync `void` 반환.
 * 실패 시 콘솔에만 남기고 추천 결과 노출 흐름을 막지 않는다.
 */
export function saveTactSuitRecommendResponse(
  input: SaveTactSuitRecommendInput,
): void {
  if (isServer) return;

  const headers: Record<string, string> = {
    "Content-Type": "application/json",
  };
  if (input.bearerToken) {
    headers["Authorization"] = `Bearer ${input.bearerToken}`;
  }

  fetch(backendUrl("admin", "/api/v1/tactsuit-recommend-responses"), {
    method: "POST",
    headers,
    body: JSON.stringify({
      sessionId: getOrCreateSessionId(),
      platforms: input.platforms,
      genres: input.genres,
      purchaseFeatures: input.purchaseFeatures,
      locale: input.locale ?? "",
    }),
    keepalive: true,
  }).catch((e) => {
    // eslint-disable-next-line no-console
    console.warn("saveTactSuitRecommendResponse failed", e);
  });
}
